import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import AtosListar from '../../components/atos/listar';


function AtosScreen () {
    return (
        <Fragment>
            <Head titulo="Atos Oficiais do Governo do Município de Macuco"/>
            <Header />
            <Container>
                <AtosListar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default AtosScreen;